// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editEquipmentNotes__L1ti_ {
  width: 720px;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-height: 760px) {
  .editEquipmentNotes__L1ti_ {
    height: 100%;
  }
}

.modalBody__QX85d {
  flex: 1;
  padding: 25px 25px 0 25px;
  overflow-y: auto;
}
.modalBody__QX85d::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.modalBody__QX85d::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.modalBody__QX85d::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.modalBody__QX85d::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-height: 760px) {
  .modalBody__QX85d {
    max-height: calc(100vh - 235px);
  }
}

.modalBodyForm__dakK0 {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.linksTableWrapper__eYnOD {
  max-height: 211px;
  overflow: auto;
  box-shadow: var(--info-block-box-shadow);
}
.linksTableWrapper__eYnOD::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.linksTableWrapper__eYnOD::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.linksTableWrapper__eYnOD::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.linksTableWrapper__eYnOD::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.linksTable__qnXdy {
  width: 100%;
  border-collapse: collapse;
  position: relative;
}
.linksTable__qnXdy th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 15px;
  background-color: var(--tables-title-surface);
  text-align: left;
  border-bottom: 1px solid var(--tables-title-stroke);
  position: sticky;
  top: 0;
  z-index: 1;
}
.linksTable__qnXdy td {
  padding: 10px 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
}

.deleteColumn__F1Bnf {
  padding-left: 0 !important;
  text-align: center;
}

.deleteIcon__AkTGr {
  cursor: pointer;
}
.deleteIcon__AkTGr path {
  stroke: var(--buttons-surface);
}

.disabledDelete__AV2UR {
  opacity: 0.5;
  cursor: not-allowed;
}

.addIcon__gtzIq path {
  fill: var(--buttons-surface);
}

.addLinkWrapper__vtBOe {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.modalFooter__U24By {
  display: flex;
  gap: 25px;
  padding: 25px;
  justify-content: flex-end;
}

.dropzoneWrapper__p3Nue {
  width: 100%;
}
.dropzoneWrapper__p3Nue label {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  margin-bottom: 6px;
  display: block;
}

.dropzone__qmQik {
  width: 100%;
  height: 250px;
  background: var(--tables-secondary-row-sub-title-surface);
  border-radius: 5px;
  overflow-y: auto;
}
.dropzone__qmQik::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.dropzone__qmQik::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.dropzone__qmQik::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.dropzone__qmQik::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditEquipmentNotesModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EAPF;IAQI,YAAA;EAxEF;AACF;;AA2EA;EACE,OAAA;EACA,yBAAA;EACA,gBAAA;AAxEF;AASE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAPJ;AAUE;EACE,+BAAA;EACA,kBAAA;AARJ;AAWE;EACE,8BAAA;EACA,kBAAA;AATJ;AAYE;EACE,gBAAA;EACA,kBAAA;AAVJ;AA2DE;EAPF;IAQI,+BAAA;EAxDF;AACF;;AA2DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxDF;;AA2DA;EACE,iBAAA;EACA,cAAA;EACA,wCAAA;AAxDF;AAzBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA2BJ;AAxBE;EACE,+BAAA;EACA,kBAAA;AA0BJ;AAvBE;EACE,8BAAA;EACA,kBAAA;AAyBJ;AAtBE;EACE,gBAAA;EACA,kBAAA;AAwBJ;;AA4CA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAzCF;AA2CE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,aAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAzCJ;AA4CE;EACE,kBAAA;EACA,yDAAA;EACA,yDAAA;AA1CJ;;AA8CA;EACE,0BAAA;EACA,kBAAA;AA3CF;;AA8CA;EACE,eAAA;AA3CF;AA6CE;EACE,8BAAA;AA3CJ;;AA+CA;EACE,YAAA;EACA,mBAAA;AA5CF;;AAgDE;EACE,4BAAA;AA7CJ;;AAiDA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;AA9CF;;AAiDA;EACE,WAAA;AA9CF;AA+CE;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AA7CJ;;AAiDA;EACE,WAAA;EACA,aAAA;EACA,yDAAA;EACA,kBAAA;EACA,gBAAA;AA9CF;AA3HE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA6HJ;AA1HE;EACE,+BAAA;EACA,kBAAA;AA4HJ;AAzHE;EACE,8BAAA;EACA,kBAAA;AA2HJ;AAxHE;EACE,gBAAA;EACA,kBAAA;AA0HJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editEquipmentNotes {\n  width: 720px;\n  height: 700px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-height: 760px) {\n    height: 100%;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  padding: 25px 25px 0 25px;\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  @media (max-height: 760px) {\n    max-height: calc(100vh - 235px);\n  }\n}\n\n.modalBodyForm {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.linksTableWrapper {\n  max-height: 211px;\n  overflow: auto;\n  box-shadow: var(--info-block-box-shadow);\n\n  @include scrollBar;\n}\n\n.linksTable {\n  width: 100%;\n  border-collapse: collapse;\n  position: relative;\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 15px;\n    background-color: var(--tables-title-surface);\n    text-align: left;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n\n  td {\n    padding: 10px 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-secondary-row-sub-title-surface);\n  }\n}\n\n.deleteColumn {\n  padding-left: 0 !important;\n  text-align: center;\n}\n\n.deleteIcon {\n  cursor: pointer;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.disabledDelete {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.addIcon {\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.addLinkWrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 15px;\n}\n\n.modalFooter {\n  display: flex;\n  gap: 25px;\n  padding: 25px;\n  justify-content: flex-end;\n}\n\n.dropzoneWrapper {\n  width: 100%;\n  label {\n    color: var(--title-inputs-sections-title);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    margin-bottom: 6px;\n    display: block;\n  }\n}\n\n.dropzone {\n  width: 100%;\n  height: 250px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border-radius: 5px;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editEquipmentNotes": `editEquipmentNotes__L1ti_`,
	"modalBody": `modalBody__QX85d`,
	"modalBodyForm": `modalBodyForm__dakK0`,
	"linksTableWrapper": `linksTableWrapper__eYnOD`,
	"linksTable": `linksTable__qnXdy`,
	"deleteColumn": `deleteColumn__F1Bnf`,
	"deleteIcon": `deleteIcon__AkTGr`,
	"disabledDelete": `disabledDelete__AV2UR`,
	"addIcon": `addIcon__gtzIq`,
	"addLinkWrapper": `addLinkWrapper__vtBOe`,
	"modalFooter": `modalFooter__U24By`,
	"dropzoneWrapper": `dropzoneWrapper__p3Nue`,
	"dropzone": `dropzone__qmQik`
};
module.exports = ___CSS_LOADER_EXPORT___;
